import gql from 'graphql-tag';

export const ExcerptIncludeQuery =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		query ExcerptIncludeQuery($contentId: ID!, $macroNode: ExperimentalMacroNode!) @experimental {
			experimentalMacroMetadata(contentId: $contentId, macroNode: $macroNode) {
				payload
				contentId
			}
		}
	`;
